import { useSelector } from "react-redux";
import { getEdgeClass } from "../../utils";
import parse from "html-react-parser";
import React from "react";
import StyledVehicleDetailsUnderlinedHeading from "../StyledVehicleDetailsUnderlinedHeading";

const VehicleFurtherFeatures = ({ vehicleDetails }) => {
  const { edge = false } = useSelector((state) => state?.uiConfig) || {};

  const transformApiHtml = (htmlString) => {
    if (!htmlString) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    let resultHtml = "";
    let currentList = [];

    doc.body.childNodes.forEach((node) => {
      const isEmptyP = node.nodeName === "P" && node.textContent.trim() === "";

      if (isEmptyP) return; // skip empty <p>

      if (node.nodeName === "P" && node.querySelector("strong")) {
        if (currentList?.length > 0) {
          resultHtml += `<ul>${currentList?.join("")}</ul>`;
          currentList = [];
        }
        resultHtml += `<h3>${node?.textContent?.trim()?.replace(/:$/, "")}</h3>`;
      } else if (node.nodeName === "UL") {
        node?.querySelectorAll("li").forEach((li) => {
          currentList?.push(`<li>${li.textContent.trim()}</li>`);
        });
      } else if (node?.nodeName === "P") {
        if (currentList?.length > 0) {
          resultHtml += `<ul>${currentList?.join("")}</ul>`;
          currentList = [];
        }
        resultHtml += `<p>${node.textContent.trim()}</p>`;
      }
    });

    // flush remaining list
    if (currentList?.length > 0) {
      resultHtml += `<ul>${currentList?.join("")}</ul>`;
    }

    return resultHtml;
  };

  const cleanedHtml = transformApiHtml(vehicleDetails?.equipmentComplete);

  const parsedContent = parse(cleanedHtml, {
    replace: (domNode) => {
      if (domNode.name === "h3") {
        return (
          <h3 className="font-semibold text-md col-span-full">
            {domNode?.children[0]?.data}
          </h3>
        );
      }
      if (domNode?.name === "p") {
        const text = domNode?.children?.[0]?.data || "";
        return (
          <p className="text-[15px] text-[var(--davy-gray-color)] leading-6 break-words [word-break:break-word]">
            {text}
          </p>
        );
      }
      if (domNode?.name === "ul") {
        const liCount = domNode?.children?.filter(
          (c) => c?.name === "li",
        ).length;

        const colCount =
          liCount === 1 ? 1 : liCount === 2 ? 2 : liCount === 3 ? 3 : 4;

        return (
          <ul
            className={`list-disc list-inside grid gap-y-1 gap-x-6  lg:grid-cols-${colCount}`}
          >
            {domNode.children.map((liNode, idx) => {
              const text = liNode.children?.[0]?.data || "";
              return (
                <li
                  key={idx}
                  title={text}
                  className={`text-[15px] text-[var(--davy-gray-color)] leading-6 break-words [word-break:break-word] ${
                    colCount >= 4 ? "truncate" : ""
                  }`}
                >
                  {text}
                </li>
              );
            })}
          </ul>
        );
      }
      return undefined;
    },
  });

  return vehicleDetails?.equipmentComplete ? (
    <section className="mt-7 max-md:mt-5">
      <div className="container 2xl:max-w-[1336px] lg:max-w-[1200px] m-auto px-2">
        <div
          className={`${getEdgeClass(edge, "rounded-[20px]")} bg-[var(--white-shade)] p-7 max-md:p-4`}
        >
          <StyledVehicleDetailsUnderlinedHeading header="Further features" />
          <div className="my-6 grid gap-y-3">{parsedContent}</div>
        </div>
      </div>
    </section>
  ) : null;
};
export default VehicleFurtherFeatures;
